import React from "react";
import { Breadcrumb, Dropdown, Button } from "react-bootstrap";
import { FiChevronUp } from "react-icons/fi";
import { HiOutlineHome } from "react-icons/hi";
import { BsFileEarmarkPdf, BsFileEarmarkExcel } from "react-icons/bs";
import { BiExport } from "react-icons/bi";
import { RiHome6Line } from "react-icons/ri";
import { MdKeyboardArrowRight } from "react-icons/md";
import { Link } from "react-router-dom";
import {  Col } from 'react-bootstrap';
import PaymentsTable from "../../components/sales/PaymentsTable";
const PaymentsPage = () => {
  return (
    <div style={{ padding: "15px", background: "#f8f9fa",  }} className="page-breadcrumb mb-3">
      <div className="d-md-flex d-block align-items-center justify-content-between">
        
        {/* LEFT SECTION */}
      
   <Col md={4} sm={12}>
                  <div className="my-auto mb-2">
                    <h4 style={{ fontWeight: "600", marginBottom: "5px" }}>Payments</h4>
        
                    <Breadcrumb
                      style={{
                        background: "transparent",
                        padding: 0,
                        margin: 0,
                        fontSize: "14px",
                      }}
                    >
                      <Breadcrumb.Item>
                      <Link  to="/" >
               
                        <RiHome6Line
                          className="m text-dark"
                          style={{
                            fontSize: "1.2rem", // increased icon size
                            verticalAlign: "middle",
                                                     }}
                        /></Link>
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item
                        linkAs="span"
                        className="text-dark text-decoration-none fs-6"
                      >
                      Sales
                      </Breadcrumb.Item>
        
                      <MdKeyboardArrowRight className="mt-1 fs-5" />
        
                      <Breadcrumb.Item active>
                        <span className="text-dark fs-6">Payments</span>
                      </Breadcrumb.Item>
                    </Breadcrumb>
                  </div>
                </Col>

        {/* RIGHT SECTION */}
        <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
          
          {/* EXPORT DROPDOWN */}
          <div className="mb-2">
            <Dropdown align="end">
              <Dropdown.Toggle
                variant="white"
                className="d-inline-flex align-items-center border"
              >
                <BiExport className="me-1" /> Export
              </Dropdown.Toggle>

              <Dropdown.Menu className="p-2">
                <Dropdown.Item className="rounded-1 d-flex align-items-center">
                  <BsFileEarmarkPdf className="me-2" />
                  Export as PDF
                </Dropdown.Item>

                <Dropdown.Item className="rounded-1 d-flex align-items-center">
                  <BsFileEarmarkExcel className="me-2" />
                  Export as Excel
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </div>

          {/* COLLAPSE ICON */}
          {/* <div className="head-icons ms-2">
            <Button
              variant="link"
              className="p-0 text-dark"
              title="Collapse"
            >
              <FiChevronUp size={18} />
            </Button>
          </div> */}
        </div>
      </div>
      <PaymentsTable/>
      <style>
          {
               `
               .page-breadcrumb h2 {
  font-size: 22px;
}

.breadcrumb {
  font-size: 14px;
  background: transparent;
}

.dropdown-toggle.btn-white {
  background-color: #fff;
  border: 1px solid #e5e7eb;
  font-size: 14px;
}

.dropdown-menu {
  min-width: 180px;
  border-radius: 8px;
}

.dropdown-item {
  font-size: 14px;
  padding: 8px 10px;
}

.head-icons button {
  display: flex;
  align-items: center;
  justify-content: center;
}

@media (max-width: 768px) {
  .page-breadcrumb {
    flex-direction: column;
  }

  .right-content {
    margin-top: 10px;
    justify-content: space-between;
    width: 100%;
  }
    

  .dropdown-toggle {
    width: 100%;
    justify-content: center;
  }
}`
          }
      </style>
    </div>
  );
};

export default PaymentsPage;